import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormControl, FormArray, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { MatDialog } from "@angular/material/dialog";
import { TokenStorageService } from "src/app/core/auth/token-storage.service";
import { ApiCallService } from "src/app/core/services/api-call-service";
import { SnackbarCollection } from "src/app/core/services/snackbar.service";
import { WidgetConfigService } from "src/app/core/services/widget-config.service";
import { ConfirmationDialogBoxComponent, ContactUsDialogComponent } from "src/app/shared/components/dialog-box";
import { environment } from "src/environments/environment";
import { OfferRulesImportDialogComponent } from "src/app/shared/components/dialog-box/offer-rules-import-dialog/offer-rules-import-dialog.component";
import { TranslateDynamicText } from "src/app/shared/pipes/dynamic-translation.pipe";

@Component({
  selector: "app-survey-creation",
  templateUrl: "./survey-creation.component.html",
  styleUrls: ["./survey-creation.component.css"],
})
export class SurveyCreationComponent implements OnInit {
  constructor(
    private snackBar: SnackbarCollection,
    private tokenStorage: TokenStorageService,
    private apiCall: ApiCallService,
    // private parentToChildService: SurveyParentService,
    private route: ActivatedRoute,
    private router: Router,
    private dialog: MatDialog,
    private _WidgetConfigService: WidgetConfigService,
    private _i18nDynamicTranslate: TranslateDynamicText
  ) {}

  @ViewChild("surveyHtml") surveyHtml: ElementRef;
  s3BucketUrl = environment;
  surveyForm: FormGroup;
  surveyArray = null;
  finalHtml;
  submitClicked: boolean = false;
  validWidgets = null;
  surveyOptions = [
    { value: 'DROPDOWN', label: 'SURVEY_PAGE.DROP_DOWN' },
    { value: 'RADIO', label: 'SURVEY_PAGE.RADIO_BUTTON' },
    { value: 'TEXT', label: 'SURVEY_PAGE.FREE_TEXT' },
    { value: 'RANGE', label: 'SURVEY_PAGE.RANGE' }
  ];
  // script =
  //  "<script>var submittingForm = false; var smileyValue = 0; var smileyTotal=0; var divIdd = document.getElementById('questionDiv'), lengg = divIdd.getElementsByTagName('p').length, data = [], finalType, count = 0, length; function submitForm() { var t, n = document.getElementById('questionDiv'), a = n.getElementsByTagName('p').length; length = a; for (i = 0; i < length; i++) { t = null; finalType = null; if (document.getElementsByName('B-' + i).length > 0) { var e = document.getElementsByName('B-' + i); for (j = 0; j < e.length; j++) { if (e[j].checked) { t = e[j].value; finalType = 'RADIO' } } }; if (document.getElementById('S-' + i)) { var e = document.getElementById('S-' + i); for (j = 0; j < e.length; j++) { if (e[j].selected) { t = e.options[j].text; finalType = 'DROPDOWN' } } }; if (document.getElementById('T-' + i)) { var e = document.getElementById('T-' + i); t = e.value; finalType = 'TEXT' }; if (document.getElementById('R-' + i)) { var n = document.getElementById('R-' + i), a = n.getElementsByTagName('div').length; for (j = 1; j <= a; j++) { var l = document.getElementById('demo' + i + j), o = window.getComputedStyle(l).backgroundColor; if (o !== 'rgb(0, 0, 0)') { var d = document.getElementById('demo' + i + j).innerHTML; t = d; finalType = 'RANGE' } } }; submitData(document.getElementById('Q-' + i).innerHTML, t, finalType) } }; function myFunction(e, n) { var t = e.id; resetColor(n); var i = document.getElementById(t), a = window.getComputedStyle(i).backgroundColor; if (a === 'rgb(0, 0, 0)') { document.getElementById(t).style.background = '#4abb59' } else { document.getElementById(t).style.background = '#000' } }; function resetColor(e) { var t = document.getElementById('R-' + e), n = t.getElementsByTagName('div').length; for (i = 1; i <= n; i++) { document.getElementById('demo' + e + i).style.background = '#000' } }; function submitData(e, t, n) { count++; if(n=='RANGE'){ smileyValue=smileyValue+t; smileyTotal=smileyTotal+10; } var i = { 'question': e, 'answer': t, 'type': n }; data.push(i); if (count === length) { if (formValidation(data)) { document.getElementById('validationDiv').innerHTML = 'All fields are mandatory'; count = 0; data = []; smileyValue=0; smileyTotal=0; return } else { document.getElementById('validationDiv').innerHTML = ''; apiCall(data,smileyValue,smileyTotal) } } }; function formValidation(e) { validateTextArea(); for (k = 0; k < e.length; k++) { if (!(e[k]['answer'])) { return !0 } }; return !1 }; function apiCall(e,smileyValue,smileyTotal) { count = 0; var n = JSON.stringify({ 'list': e, 'url': window.location.href }); var t = new XMLHttpRequest(); t.open('POST', 'https://" +environment.domain +"/ezloyal-web/survey/submitFeedback/shopify/reviews/',!0);t.setRequestHeader('Content-type','application/json');t.send(n);t.onreadystatechange=function(){if(this.readyState==4&&this.status==200){submittingForm=true;document.getElementById('mainDiv').innerHTML='';document.getElementById('feedbackDiv').style.padding='10%';	document.getElementById('feedbackSpan').innerHTML =`<div style='dispaly:flex;width:100%;justify-content: center;align-items:center;flex-direction:column; width: 100%; display: flex;'> <div id ='smileySvg'> </div> <div style='font-size: 42px;font-weight: bold; font-stretch: normal; font-style: normal; line-height: normal; letter-spacing: normal; color: #222222;margin-top: 10px;'> Thank You!</div> <div style=' font-size: 18px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: normal; letter-spacing: normal; text-align: center; margin-top: 10px; color: #222222;'>Thank you for sharing your thoughts.</div> <div style=' font-size: 18px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: normal; letter-spacing: normal; text-align: center; color: #222222;'> We appreciate your feedback</div> </div>`; if(smileyValue){ var smileyPercentage=(smileyValue*100)/(smileyTotal); if(smileyPercentage>=70){ document.getElementById('smileySvg').innerHTML = `<img src ='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/Happy1.svg' alt='' >`; }else if(smileyPercentage<70&&smileyPercentage>=50){ document.getElementById('smileySvg').innerHTML = `<img src ='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/neutral.svg' alt='' > `; } else{ document.getElementById('smileySvg').innerHTML = `<img src ='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/sad.svg' alt='' >`; } } else{ document.getElementById('smileySvg').innerHTML = `<img src ='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/Happy1.svg' alt='' >`; }}}};var checkLength=function(){for(i=0;i<lengg;i++){if(document.getElementById('T-'+i)){if(document.getElementById('T-'+i).value.length<=200){if((1000-document.getElementById('T-'+i).value.length)>=2){document.getElementById('V-'+i).innerHTML=(1000-document.getElementById('T-'+i).value.length)+' characters remaining'}else{document.getElementById('V-'+i).innerHTML=(1000-document.getElementById('T-'+i).value.length)+' character remaining'}}}}};setInterval(checkLength,300);function trimfield(e){return e.replace(/^s+|s+$/g,'')};function validateTextArea(){for(i=0;i<lengg;i++){if(document.getElementById('T-'+i)){var e=document.getElementById('T-'+i);if(e.value.trim()==''){alert('Text area should not be empty');e.focus();return!1}else{}}}};window.onbeforeunload = function(){ if(submittingForm)return undefined;return 'Are you sure you want to leave?'; };</script>";
  // script =
  //   "<script>var submittingForm = false; var divIdd = document.getElementById('questionDiv'), lengg = divIdd.getElementsByTagName('p').length, data = [], internalData = [], finalType, count = 0, length; function submitForm() { var t, n = document.getElementById('questionDiv'), a = n.getElementsByTagName('p').length; length = a; for (i = 0; i < length; i++) { t = null; finalType = null; var x; if (document.getElementsByName('B-' + i).length > 0) { var e = document.getElementsByName('B-' + i); var clickCheck = 0; for (j = 0; j < e.length; j++) { if (e[j].checked) { t = e[j].value; finalType = 'RADIO'; } else { clickCheck++; if (clickCheck == e.length) { t = ''; finalType = 'RADIO'; } } } }; if (document.getElementById('S-' + i)) { var e = document.getElementById('S-' + i); for (j = 0; j < e.length; j++) { if (e[j].selected) { t = e.options[j].text; finalType = 'DROPDOWN'; } } }; if (document.getElementById('T-' + i)) { var e = document.getElementById('T-' + i); t = e.value; finalType = 'TEXT'; }; if (document.getElementById('R-' + i)) { var n = document.getElementById('R-' + i), x = document.getElementById('Q-' + i).getAttribute('required'); a = n.getElementsByTagName('div').length; var clickCheck = 0; for (j = 1; j <= a; j++) { var l = document.getElementById('demo' + i + j), o = window.getComputedStyle(l).backgroundColor; if (o !== 'rgb(0, 0, 0)') { var d = document.getElementById('demo' + i + j).innerHTML; t = d; finalType = 'RANGE'; } else { clickCheck++; if (clickCheck == 10) { t = ''; finalType = 'RANGE'; } } } }; submitData(document.getElementById('Q-' + i).innerHTML, t, finalType, document.getElementById('Q-' + i).getAttribute('required'), i); } }; function myFunction(e, n) { var t = e.id; resetColor(n); var i = document.getElementById(t); a = window.getComputedStyle(i).backgroundColor; if (a === 'rgb(0, 0, 0)') { document.getElementById(t).style.background = '#4abb59'; } else { document.getElementById(t).style.background = '#000'; } }; function resetColor(e) { var t = document.getElementById('R-' + e), n = t.getElementsByTagName('div').length; for (i = 1; i <= n; i++) { document.getElementById('demo' + e + i).style.background = '#000'; } }; function submitData(e, t, n, x, ji) {  var i = { 'question': e, 'answer': t, 'type': n }; data.push(i); var p = { 'question': e, 'answer': t, 'type': n, 'required': x }; internalData.push(p); if (ji == length - 1) { if (!validateForms(internalData)) { internalData = []; data = []; document.getElementById('validationDiv').innerHTML = 'All fields marked with asterisk(*) are required'; } else { document.getElementById('validationDiv').innerHTML = ''; apiCall(data); } } }; function validateForms(dat) { var c = 0; for (c = 0; c < dat.length; c++) { if (dat[c].required == 'true') { if (dat[c].type == 'TEXT') { if (!validateTextArea(c)) { return !1 } } else { if (dat[c].answer == null || dat[c].answer == '') { dat[c].answer = null; return !1 } } } else { if (dat[c].answer == null || dat[c].answer == '') { dat[c].answer = ''; } } if (c == dat.length - 1) { return true; } } } function formValidation(e) { validateTextArea(1); for (k = 0; k < e.length; k++) { if (!(e[k]['answer'])) { return !0; } }; return !1; }; function apiCall(e) { data = []; count = 0; var n = JSON.stringify({ 'list': e, 'url': window.location.href }); var t = new XMLHttpRequest(); t.open('POST', 'https://" +
  //   environment.domain +
  //   "/ezloyal-web/survey/submitFeedback/shopify/reviews/', !0); t.setRequestHeader('Content-type', 'application/json'); t.send(n); internalData = []; data = []; t.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) {submittingForm=true; document.getElementById('mainDiv').innerHTML = ''; document.getElementById('feedbackDiv').style.padding = '10%'; document.getElementById('feedbackSpan').innerHTML = `<div style='dispaly:flex;width:100%;justify-content: center;align-items:center;flex-direction:column; width: 100%; display: flex;'><div style=' font-size: 32px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: normal; letter-spacing: normal; text-align: center; margin-top: 10px; color: #222222;'>Thank you for sharing your thoughts.</div><div style=' font-size: 32px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: normal; letter-spacing: normal; text-align: center; color: #222222;'>We appreciate your feedback.</div><div id='smileySvg'></div></div>`; document.getElementById('smileySvg').innerHTML = `<img src='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/Survey_Completion.png'width='400'height='400'alt=''>`; } } }; var checkLength = function() { for (i = 0; i < lengg; i++) { if (document.getElementById('T-' + i)) { if (document.getElementById('T-' + i).value.length <= 1000) { if ((1000 - document.getElementById('T-' + i).value.length) >= 2) { document.getElementById('V-' + i).innerHTML = (1000 - document.getElementById('T-' + i).value.length) + ' characters remaining'; } else { document.getElementById('V-' + i).innerHTML = (1000 - document.getElementById('T-' + i).value.length) + ' character remaining'; } } } } }; function validateTextArea(index) { if (document.getElementById('T-' + index) && document.getElementById('Q-' + index).getAttribute('required')) { var e = document.getElementById('T-' + index); if (e.value.trim() == '') { alert('Text area should not be empty'); e.focus(); return !1; } else { return 1; } } }; function displayScreen(screen) { if (screen == 'new') { submittingForm = false; document.querySelector('.session-newsurvey').style.display = 'block'; document.querySelector('.session-surveycheck').style.display = 'none'; document.querySelector('.session-error').style.display = 'none'; } else if (screen == 'old') { submittingForm = true; document.querySelector('.session-newsurvey').style.display = 'none'; document.querySelector('.session-surveycheck').style.display = 'block'; document.querySelector('.session-error').style.display = 'none'; } else if (screen == 'error') { submittingForm = true; document.querySelector('.session-newsurvey').style.display = 'none'; document.querySelector('.session-surveycheck').style.display = 'none'; document.querySelector('.session-error').style.display = 'block'; } else {} } window.onbeforeunload = function() { if (submittingForm) return undefined; return 'Are you sure you want to leave?'; }; window.onload = submissionCheckStatus(); function submissionCheckStatus() { document.querySelector('.session-newsurvey').style.display = 'none'; document.querySelector('.session-surveycheck').style.display = 'none'; var e = new XMLHttpRequest; let params = (new URL(document.location)).searchParams; let urlParam = params.get('surveyToken'); if (urlParam) { e.onreadystatechange = function() { 4 == this.readyState && 200 == this.status && ((JSON.parse(this.responseText).body.length == 0) ? displayScreen('new') : displayScreen('old')), 4 == this.readyState && 500 == this.status && displayScreen('error'); }; var t = 'https://" +
  //   environment.domain +
  //   "/ezloyal-web/survey/duplicateSurvey/shopify/reviews?surveyToken=' + urlParam; e.open('GET', t, !0); e.send(); } else { document.querySelector('.session-surveycheck').style.display = 'flex'; displayScreen('error'); } }; setInterval(checkLength, 300); </script>";
  style =
    "<style>.slidecontainer { width: 100%; } .slider { padding: 5px 0;border: none; width: 100%; height: 15px; border-radius: 5px; background: #c6ced6; outline: none; opacity: 0.7; -webkit-transition: .2s; transition: opacity .2s; } .slider:hover { opacity: 1; } .slider::-webkit-slider-thumb { -webkit-appearance: none; appearance: none; width: 25px; height: 25px; border-radius: 50%; background: #dedede; cursor: pointer; } .slider::-moz-range-thumb { width: 25px; height: 25px; border-radius: 50%; background: #dedede; cursor:pointer; }</style>";
  script =
    "<script>var submittingForm = false; var divIdd = document.getElementById('questionDiv'), lengg = divIdd.getElementsByTagName('p').length, data = [], internalData = [], finalType, count = 0, length; function submitForm() { var t, n = document.getElementById('questionDiv'), a = n.getElementsByTagName('p').length; length = a; for (i = 0; i < length; i++) { t = null; finalType = null; var x; if (document.getElementsByName('B-' + i).length > 0) { var e = document.getElementsByName('B-' + i); var clickCheck = 0; for (j = 0; j < e.length; j++) { if (e[j].checked) { t = e[j].value; finalType = 'RADIO'; } else { clickCheck++; if (clickCheck == e.length) { t = ''; finalType = 'RADIO'; } } } }; if (document.getElementById('S-' + i)) { var e = document.getElementById('S-' + i); for (j = 0; j < e.length; j++) { if (e[j].selected) { t = e.options[j].text; finalType = 'DROPDOWN'; } } }; if (document.getElementById('T-' + i)) { var e = document.getElementById('T-' + i); t = e.value; finalType = 'TEXT'; }; if (document.getElementById('R-' + i)) { var n = document.getElementById('R-' + i), x = document.getElementById('Q-' + i).getAttribute('required'); a = n.getElementsByTagName('div').length; var clickCheck = 0; t=n.value;finalType = 'RANGE'; }; submitData(document.getElementById('Q-' + i).innerHTML, t, finalType, document.getElementById('Q-' + i).getAttribute('required'), i); } }; function myFunction(e, n) { var t = e.id; resetColor(n); var i = document.getElementById(t); a = window.getComputedStyle(i).backgroundColor; if (a === 'rgb(0, 0, 0)') { document.getElementById(t).style.background = '#4abb59'; } else { document.getElementById(t).style.background = '#000'; } }; function resetColor(e) { var t = document.getElementById('R-' + e), n = t.getElementsByTagName('div').length; for (i = 1; i <= n; i++) { document.getElementById('demo' + e + i).style.background = '#000'; } }; function submitData(e, t, n, x, ji) { var i = { 'question': e, 'answer': t, 'type': n }; data.push(i); var p = { 'question': e, 'answer': t, 'type': n, 'required': x }; internalData.push(p); if (ji == length - 1) { if (!validateForms(internalData)) { internalData = []; data = []; document.getElementById('validationDiv').innerHTML = 'All fields marked with asterisk(*) are required'; } else { document.getElementById('validationDiv').innerHTML = ''; apiCall(data); } } }; function validateForms(dat) { var c = 0; for (c = 0; c < dat.length; c++) { if (dat[c].required == 'true') { if (dat[c].type == 'TEXT') { if (!validateTextArea(c)) { return !1 } } else { if (dat[c].answer == null || dat[c].answer == '') { dat[c].answer = null; return !1 } } } else { if (dat[c].answer == null || dat[c].answer == '') { dat[c].answer = ''; } } if (c == dat.length - 1) { return true; } } } function formValidation(e) { validateTextArea(1); for (k = 0; k < e.length; k++) { if (!(e[k]['answer'])) { return !0; } }; return !1; }; function apiCall(e) { data = []; count = 0; var n = JSON.stringify({ 'list': e, 'url': window.location.href }); var t = new XMLHttpRequest(); t.open('POST', 'https://" +
    environment.domain +
    "/ezloyal-web/survey/submitFeedback/"+this.getShopName()+"/reviews/', !0); t.setRequestHeader('Content-type', 'application/json'); t.send(n); internalData = []; data = []; t.onreadystatechange = function() { if (this.readyState == 4 && this.status == 200) {submittingForm=true; document.getElementById('mainDiv').innerHTML = ''; document.getElementById('feedbackDiv').style.padding = '10%'; document.getElementById('feedbackSpan').innerHTML = `<div style='dispaly:flex;width:100%;justify-content: center;align-items:center;flex-direction:column; width: 100%; display: flex;'><div style=' font-size: 32px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: normal; letter-spacing: normal; text-align: center; margin-top: 10px; color: #222222;'>Thank you for sharing your thoughts.</div><div style=' font-size: 32px; font-weight: normal; font-stretch: normal; font-style: normal; line-height: normal; letter-spacing: normal; text-align: center; color: #222222;'>We appreciate your feedback.</div><div id='smileySvg'></div></div>`; document.getElementById('smileySvg').innerHTML = `<img src='https://cdn-greyfox.s3.ap-south-1.amazonaws.com/greyfox-assets/assets2/survey-assets/Survey_Completion.png'width='400'height='400'alt=''>`; } } }; var checkLength = function() { for (i = 0; i < lengg; i++) { if (document.getElementById('T-' + i)) { if (document.getElementById('T-' + i).value.length <= 1000) { if ((1000 - document.getElementById('T-' + i).value.length) >= 2) { document.getElementById('V-' + i).innerHTML = (1000 - document.getElementById('T-' + i).value.length) + ' characters remaining'; } else { document.getElementById('V-' + i).innerHTML = (1000 - document.getElementById('T-' + i).value.length) + ' character remaining'; } } } } }; function validateTextArea(index) { if (document.getElementById('T-' + index) && document.getElementById('Q-' + index).getAttribute('required')) { var e = document.getElementById('T-' + index); if (e.value.trim() == '') { alert('Text area should not be empty'); e.focus(); return !1; } else { return 1; } } }; function displayScreen(screen) { if (screen == 'new') { submittingForm = false; document.querySelector('.session-newsurvey').style.display = 'block'; document.querySelector('.session-surveycheck').style.display = 'none'; document.querySelector('.session-error').style.display = 'none'; } else if (screen == 'old') { submittingForm = true; document.querySelector('.session-newsurvey').style.display = 'none'; document.querySelector('.session-surveycheck').style.display = 'block'; document.querySelector('.session-error').style.display = 'none'; } else if (screen == 'error') { submittingForm = true; document.querySelector('.session-newsurvey').style.display = 'none'; document.querySelector('.session-surveycheck').style.display = 'none'; document.querySelector('.session-error').style.display = 'block'; } else {} } window.onbeforeunload = function() { if (submittingForm) return undefined; return 'Are you sure you want to leave?'; }; window.onload = submissionCheckStatus(); function submissionCheckStatus() { document.querySelector('.session-newsurvey').style.display = 'none'; document.querySelector('.session-surveycheck').style.display = 'none'; var e = new XMLHttpRequest; let params = (new URL(document.location)).searchParams; let urlParam = params.get('surveyToken'); if (urlParam) { e.onreadystatechange = function() { 4 == this.readyState && 200 == this.status && ((JSON.parse(this.responseText).body.length == 0) ? displayScreen('new') : displayScreen('old')), 4 == this.readyState && 500 == this.status && displayScreen('error'); }; var t = 'https://" +
    environment.domain +
    "/ezloyal-web/survey/duplicateSurvey/"+this.getShopName()+"/reviews?surveyToken=' + urlParam; e.open('GET', t, !0); e.send(); } else { document.querySelector('.session-surveycheck').style.display = 'flex'; displayScreen('error'); } }; setInterval(checkLength, 300);</script>";
  templateId;
  surveyDetail;

  formempty: boolean = true;
  type = "custom";
  n;
  buttonSaveSurveyLoading: boolean = false;
  buttonSaveAndScheduleLoading: boolean = false;
  @ViewChild("mainHeader") mainHeader: ElementRef;
  @ViewChild("mainContainer") mainContainer: ElementRef;
  @ViewChild("previewHeading") previewHeading: ElementRef;
  createContainerHeight;
  previewHeadingHeight;
  cloneAction: boolean = false;
  styleUrl = this.s3BucketUrl.s3SurveyCssUrl;
  scriptUrl = this.s3BucketUrl.s3SurveyScriptIsUrl;
  scriptPosUrl = this.s3BucketUrl.s3SurveyPosScriptIsUrl;
  isPos = false;
  ngAfterViewInit() {
    let interval = setInterval(() => {
      if (this.mainContainer && this.mainHeader) {
        this.createContainerHeight =
          this.mainContainer.nativeElement.offsetHeight - 200;
        this.previewHeadingHeight =
          this.mainContainer.nativeElement.offsetHeight - 0;
      }
    });
  }
  ngOnInit() {
    this.getWidgets();
    this.initializeForm();
    let ispos = this.tokenStorage.getMerchantOnlineStore();
    if(ispos === 'shopify'){
      this.isPos = false;
    }
    if(ispos !== 'shopify'){
      this.isPos = true;
    }
    this.route.params.subscribe((param) => {
      this.templateId = param["id"];
      if (param["type"] != undefined) {
        this.type = param["type"];
      }
      if (param["clone"] === "1") {
        this.cloneAction = true;
      }
      // this.parentToChildService.setId(this.templateId);
      if (param["id"] === "null") {
        this.submitClicked = false;
        this.surveyForm.reset();
        this.initializeForm();
      } else {
        this.apiCall.getSurveyTemplate(this.templateId).subscribe(
          (response) => {
            if (response["message"] === "SUCCESS") {
              this.formempty = false;
              let masterSurvey = JSON.parse(response["body"]);
              if (this.cloneAction) {
                masterSurvey["name"] = masterSurvey["name"] + "_copy";
              }
              this.prefillForm(
                masterSurvey["layoutJson"],
                masterSurvey["name"],
                masterSurvey["title"]
              );
            } else {
              this.router.navigate(["/app/surveys/add-survey", { id: null }]);
            }
          },
          (err) => {
            this.router.navigate(["/app/surveys/add-survey", { id: null }]);
          }
        );
      }
    });
  }

  async getWidgets() {
    this.validWidgets = await this._WidgetConfigService.getWidget();
  }

  ngOnDestroy() {
    // this.parentToChildService.setId(null);
  }

  prefillForm(surveyJson, surveyName?, surveyTitle?) {
    surveyJson = JSON.parse(surveyJson);
    if (surveyName) {
      (<FormArray>this.surveyForm.get("surveyName")).setValue(surveyName);
      (<FormArray>this.surveyForm.get("surveyTitle")).setValue(surveyTitle);
    }

    if (this.type == "standard") {
      this.surveyForm.controls["surveyName"].disable();
    } else {
    }

    (<FormArray>this.surveyForm.get("SurveyQuestionArray")).removeAt(0);
    for (let i = 0; i < surveyJson.length; i++) {
      let question = new FormGroup({
        surveyQuestion: new FormControl(
          surveyJson[i].surveyQuestion,
          Validators.compose([Validators.maxLength(150), Validators.required])
        ),
        questionRequired: new FormControl(
          surveyJson[i].questionRequired == "true" ||
          surveyJson[i].questionRequired == true
            ? "true"
            : ""
        ),
        surveyFeedbackType: new FormControl(surveyJson[i].surveyFeedbackType),
        surveyRatingMaxValue: new FormControl(),
        surveyRatingMinText: new FormControl(),
        surveyRatingMaxText: new FormControl(),
        surveyDropDownEntriesArray: new FormArray([
          new FormGroup({
            surveyDropDownEntry: new FormControl("", Validators.required),
          }),
        ]),
        surveyRadioEntriesArray: new FormArray([
          new FormGroup({
            surveyRadioEntry: new FormControl("", Validators.required),
          }),
        ]),
      });
      (<FormArray>this.surveyForm.get("SurveyQuestionArray")).push(question);
      if (surveyJson[i].surveyFeedbackType === "DROPDOWN") {
        this.updateEntry(
          "DROPDOWN",
          surveyJson[i].surveyDropDownEntriesArray,
          i
        );
      }
      if (surveyJson[i].surveyFeedbackType === "RADIO") {
        this.updateEntry("RADIO", surveyJson[i].surveyRadioEntriesArray, i);
      }
    }
  }

  initializeForm() {
    this.surveyForm = new FormGroup({
      surveyName: new FormControl(
        "",
        Validators.compose([Validators.maxLength(100), Validators.required])
      ),
      surveyTitle: new FormControl(
        "",
        Validators.compose([Validators.maxLength(100), Validators.required])
      ),
      SurveyQuestionArray: new FormArray([
        new FormGroup({
          surveyQuestion: new FormControl(
            "",
            Validators.compose([Validators.maxLength(150), Validators.required])
          ),
          questionRequired: new FormControl(true),
          surveyFeedbackType: new FormControl("DROPDOWN"),
          surveyRatingMaxValue: new FormControl(),
          surveyRatingMinText: new FormControl(),
          surveyRatingMaxText: new FormControl(),
          surveyDropDownEntriesArray: new FormArray([
            new FormGroup({
              surveyDropDownEntry: new FormControl("", Validators.required),
            }),
          ]),
          surveyRadioEntriesArray: new FormArray([
            new FormGroup({
              surveyRadioEntry: new FormControl("", Validators.required),
            }),
          ]),
        }),
      ]),
    });
  }

  addSurveyQuestion(type: string) {
    const control = new FormGroup({
      surveyQuestion: new FormControl(
        "",
        Validators.compose([Validators.maxLength(150), Validators.required])
      ),
      questionRequired: new FormControl(true),
      surveyFeedbackType: new FormControl(type),
      surveyRatingMaxValue: new FormControl(),
      surveyRatingMinText: new FormControl(),
      surveyRatingMaxText: new FormControl(),
      surveyDropDownEntriesArray: new FormArray([
        new FormGroup({
          surveyDropDownEntry: new FormControl("", Validators.required),
        }),
      ]),
      surveyRadioEntriesArray: new FormArray([
        new FormGroup({
          surveyRadioEntry: new FormControl("", Validators.required),
        }),
      ]),
    });
    (<FormArray>this.surveyForm.get("SurveyQuestionArray")).push(control);
    var i = (<FormArray>this.surveyForm.get("SurveyQuestionArray")).length - 1;

    this.formempty = false;

    setTimeout(() => {
      document.getElementById("surveysec-" + i).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "start",
      });
    }, 500);
  }

  addSurveyQuestiontypeDropdown(type) {
    const control = new FormGroup({
      surveyQuestion: new FormControl(
        "",
        Validators.compose([Validators.maxLength(150), Validators.required])
      ),
      surveyFeedbackType: new FormControl("DROPDOWN"),
      surveyDropDownEntriesArray: new FormArray([
        new FormGroup({
          surveyDropDownEntry: new FormControl("", Validators.required),
        }),
      ]),
    });
    (<FormArray>this.surveyForm.get("SurveyQuestionArray")).push(control);
  }

  removeSurveyQuestion(questionIndex) {
    (<FormArray>this.surveyForm.get("SurveyQuestionArray")).removeAt(
      questionIndex
    );
  }

  addRadioEntry(QuestionIndex) {
    const control = new FormGroup({
      surveyRadioEntry: new FormControl("", Validators.required),
    });
    (<FormArray>(
      this.surveyForm
        .get("SurveyQuestionArray")
        ["controls"][QuestionIndex].get("surveyRadioEntriesArray")
    )).push(control);

    var j =
      this.surveyForm
        .get("SurveyQuestionArray")
        ["controls"][QuestionIndex].get("surveyRadioEntriesArray").controls
        .length - 1;
    var a = "radiobuttonentry-" + QuestionIndex + "-" + j;
    setTimeout(() => {
      document.getElementById(a).focus();
    }, 600);
  }

  addDropdownEntry(QuestionIndex) {
    const control = new FormGroup({
      surveyDropDownEntry: new FormControl("", Validators.required),
    });
    (<FormArray>(
      this.surveyForm
        .get("SurveyQuestionArray")
        ["controls"][QuestionIndex].get("surveyDropDownEntriesArray")
    )).push(control);
    var j =
      this.surveyForm
        .get("SurveyQuestionArray")
        ["controls"][QuestionIndex].get("surveyDropDownEntriesArray").controls
        .length - 1;
    var a = "dropdownentry-" + QuestionIndex + "-" + j;
    setTimeout(() => {
      document.getElementById(a).focus();
    }, 600);
  }

  updateEntry(entryType, entryJson, questionIndex) {
    if (entryType === "DROPDOWN") {
      (<FormArray>(
        this.surveyForm
          .get("SurveyQuestionArray")
          ["controls"][questionIndex].get("surveyDropDownEntriesArray")
      )).removeAt(0);
      for (let i = 0; i < entryJson.length; i++) {
        let dropDownEntry = new FormGroup({
          surveyDropDownEntry: new FormControl(
            entryJson[i].surveyDropDownEntry,
            Validators.required
          ),
        });
        (<FormArray>(
          this.surveyForm
            .get("SurveyQuestionArray")
            ["controls"][questionIndex].get("surveyDropDownEntriesArray")
        )).push(dropDownEntry);
      }
    }
    if (entryType === "RADIO") {
      (<FormArray>(
        this.surveyForm
          .get("SurveyQuestionArray")
          ["controls"][questionIndex].get("surveyRadioEntriesArray")
      )).removeAt(0);
      for (let i = 0; i < entryJson.length; i++) {
        let radioEntry = new FormGroup({
          surveyRadioEntry: new FormControl(
            entryJson[i].surveyRadioEntry,
            Validators.required
          ),
        });
        (<FormArray>(
          this.surveyForm
            .get("SurveyQuestionArray")
            ["controls"][questionIndex].get("surveyRadioEntriesArray")
        )).push(radioEntry);
      }
    }
  }

  removeRadioEntry(questionIndex, entryIndex) {
    (<FormArray>(
      this.surveyForm
        .get("SurveyQuestionArray")
        ["controls"][questionIndex].get("surveyRadioEntriesArray")
    )).removeAt(entryIndex);
  }

  removeDropdownEntry(questionIndex, entryIndex) {
    (<FormArray>(
      this.surveyForm
        .get("SurveyQuestionArray")
        ["controls"][questionIndex].get("surveyDropDownEntriesArray")
    )).removeAt(entryIndex);
  }

  selectSurveyType(index, type) {
    (<FormArray>(
      this.surveyForm
        .get("SurveyQuestionArray")
        ["controls"][index].get("surveyFeedbackType")
    )).setValue(type);
  }

  submitSurvey(buttonPurpose: string) {
    if (buttonPurpose == "SaveSurvey") {
      this.buttonSaveSurveyLoading = true;
      this.buttonSaveAndScheduleLoading = false;
    } else {
      this.buttonSaveSurveyLoading = false;
      this.buttonSaveAndScheduleLoading = true;
    }
    this.submitClicked = true;
    if (this.validateFormFields()) {
      this.buttonSaveSurveyLoading = false;
      this.buttonSaveAndScheduleLoading = false;

      return;
    }
    this.surveyArray = this.surveyForm.getRawValue();
    this.surveyArray = this.surveyArray.SurveyQuestionArray;
    let interval = setInterval(() => {
      this.addRating(buttonPurpose);
      clearInterval(interval);
    }, 500);
  }

  addRating(buttonPurpose) {
    let ratingContainer: string = null;
    let extraContent =
      "<head><link rel='stylesheet' type='text/css' href='" +
      this.styleUrl +
      "'/>  </head><body>";
    this.finalHtml =
      extraContent +
      this.surveyHtml.nativeElement.innerHTML +
      "<script src='" +
      this.getScript() +
      "'></script></body>";

    var t, r;
    if (buttonPurpose == "SaveSurvey") {
      this.buttonSaveSurveyLoading = true;
      this.buttonSaveAndScheduleLoading = false;
      t = this._i18nDynamicTranslate.transform("Do you want to Save the Survey Template?", ['POS_PAGE']);
      r = this._i18nDynamicTranslate.transform("Save and Exit", ['POS_PAGE']);
    } else {
      this.buttonSaveSurveyLoading = false;
      this.buttonSaveAndScheduleLoading = true;
      t =
        this._i18nDynamicTranslate.transform("Do you want to save the Survey Template and Schedule it for sending?", ['POS_PAGE']);
      r = this._i18nDynamicTranslate.transform("Save and Schedule", ['POS_PAGE']);
    }

    const dialogRef = this.dialog.open(ConfirmationDialogBoxComponent, {
      panelClass: "no-padding-dialog-popup",
      width: "20%",
      data: {
        subject: t,
        message: "",
        "data-widget": "SURVEY CREATE/EDIT",
        "data-button": "Save Survey",
        "data-item": "",
        cancelButtonText: this._i18nDynamicTranslate.transform("Cancel", ['POS_PAGE']),
        successButtonText: r,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.saveSurveyTemplate(buttonPurpose);
      } else {
        this.buttonSaveSurveyLoading = false;
        this.buttonSaveAndScheduleLoading = false;
      }
    });
  }

  validateFormFields() {
    if (<FormArray>this.surveyForm.get("surveyName").errors || this.surveyForm.controls.surveyName.value.split(' ').join('').length == 0) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform("Please fill the Survey Template Name field", ['POS_PAGE']),
        2000
      );
      return true;
    }
    if (<FormArray>this.surveyForm.get("surveyTitle").errors || this.surveyForm.controls.surveyTitle.value.split(' ').join('').length == 0) {
      this.snackBar.openSnackBar(
        this._i18nDynamicTranslate.transform("Please fill the Survey Title field", ['POS_PAGE']),
        2000
      );
      return true;
    }
    for (
      let i = 0;
      i <
      (<FormArray>this.surveyForm.get("SurveyQuestionArray"))["controls"]
        .length;
      i++
    ) {
      if (
        (<FormArray>(
          this.surveyForm
            .get("SurveyQuestionArray")
          ["controls"][i].get("surveyQuestion")
        )).errors || this.surveyForm
        .get("SurveyQuestionArray")
      ["controls"][i].get("surveyQuestion").value.split(' ').join('').length == 0
      ) {
        this.snackBar.openSnackBar(this._i18nDynamicTranslate.transform("Please check Question field", ['POS_PAGE']), 2000);
        return true;
      }
      if (
        (<FormArray>(
          this.surveyForm
            .get("SurveyQuestionArray")
            ["controls"][i].get("surveyFeedbackType")
        )).value === "DROPDOWN"
      ) {
        for (
          let j = 0;
          j <
          (<FormArray>(
            this.surveyForm
              .get("SurveyQuestionArray")
              ["controls"][i].get("surveyDropDownEntriesArray")
          ))["controls"].length;
          j++
        ) {
          if (
            (<FormArray>(
              this.surveyForm
                .get("SurveyQuestionArray")
              ["controls"][i].get("surveyDropDownEntriesArray")
              ["controls"][j].get("surveyDropDownEntry")
            )).errors || this.surveyForm
            .get("SurveyQuestionArray")
          ["controls"][i].get("surveyDropDownEntriesArray")
          ["controls"][j].get("surveyDropDownEntry").value.split(' ').join('').length == 0
          ) {
            this.snackBar.openSnackBar(this._i18nDynamicTranslate.transform("Please check Dropdown field", ['POS_PAGE']), 2000);
            return true;
          }
        }
      }
      if (
        (<FormArray>(
          this.surveyForm
            .get("SurveyQuestionArray")
            ["controls"][i].get("surveyFeedbackType")
        )).value === "RADIO"
      ) {
        for (
          let k = 0;
          k <
          (<FormArray>(
            this.surveyForm
              .get("SurveyQuestionArray")
              ["controls"][i].get("surveyRadioEntriesArray")
          ))["controls"].length;
          k++
        ) {
          if (
            (<FormArray>(
              this.surveyForm
                .get("SurveyQuestionArray")
              ["controls"][i].get("surveyRadioEntriesArray")
              ["controls"][k].get("surveyRadioEntry")
            )).errors || this.surveyForm
            .get("SurveyQuestionArray")
          ["controls"][i].get("surveyRadioEntriesArray")
          ["controls"][k].get("surveyRadioEntry").value.split(' ').join('').length == 0
          ) {
            this.snackBar.openSnackBar(this._i18nDynamicTranslate.transform("Please check Radio field", ['POS_PAGE']), 2000);
            return true;
          }
        }
      }
    }
  }

  saveSurveyTemplate(buttonPurpose: string) {
    let data;
    let operation;
    this.templateId = this.cloneAction ? "null" : this.templateId;
    if (this.templateId === "null") {
      operation = "CREATE";
      data = {
        name: this.surveyForm.get("surveyName").value,
        title: this.surveyForm.get("surveyTitle").value,
        merchantId: this.tokenStorage.getMerchantId(),
        layoutHtml: this.finalHtml,
        layoutJson: JSON.stringify(this.surveyArray),
        subject: "Customer survey",
      };
    } else {
      operation = "UPDATE";
      data = {
        id: this.templateId,
        name: this.surveyForm.get("surveyName").value,
        title: this.surveyForm.get("surveyTitle").value,
        merchantId: this.tokenStorage.getMerchantId(),
        layoutHtml: this.finalHtml,
        layoutJson: JSON.stringify(this.surveyArray),
        subject: "Customer survey",
      };
    }
    this.apiCall.saveSurveyTemplate(data, operation).subscribe(
      (response) => {
        if (response["message"] === "SUCCESS") {
          this.buttonSaveSurveyLoading = false;
          this.buttonSaveAndScheduleLoading = true;
          var idnumber = response["body"];
          if (buttonPurpose == "SaveSurveyaAndSchedule") {
            this.router.navigate([
              "/app/surveys/survey-list/schedule",
              { id: idnumber, loc: "new" },
            ]);
            // this.parentToChildService.publish('call-parent');
            this.snackBar.openSnackBar(this._i18nDynamicTranslate.transform("Successfully created", ['POS_PAGE']), 2000);
          } else {
            this.router.navigate([
              "/app/surveys/survey-list",
              { id: idnumber, type: this.type },
            ]);
            // this.parentToChildService.publish('call-parent');
            this.snackBar.openSnackBar(this._i18nDynamicTranslate.transform("Successfully created", ['POS_PAGE']), 2000);
          }
        } else {
          this.snackBar.openSnackBar(this._i18nDynamicTranslate.transform("Failed to add survey", ['POS_PAGE']), 2000);
        }
      },
      (err) => {
        const dialogRef = this.dialog.open(ContactUsDialogComponent, {
          panelClass: "no-padding-dialog-popup",
          height: "auto",
          disableClose: true,
          width: "380px",
          data: {
            header: this._i18nDynamicTranslate.transform("Warning", ['POS_PAGE']),
            body: err.error["body"],
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          // this.disabled = false;
          this.buttonSaveSurveyLoading = false;
          this.buttonSaveAndScheduleLoading = false;
        });
      }
    );
  }

  addnewQuestion() {
    if (this.formempty) {
      this.removeSurveyQuestion(0);
    }
    this.addSurveyQuestion("DROPDOWN");

    // const dialogSet = this.dialog.open(SurveyGroupDialogComponent, {
    //   width: "auto",
    //   height: "auto",
    //   disableClose: true,
    // });
    // dialogSet.afterClosed().subscribe((result) => {
    //   if (this.formempty) {
    //     this.removeSurveyQuestion(0);
    //   }

    //   if (result.event != "Cancel") {
    //     this.formempty = false;
    //   }
    //   if (result.event == "DROPDOWN") {
    //     this.addSurveyQuestion("DROPDOWN");
    //   } else if (result.event == "RADIO") {
    //     this.addSurveyQuestion("RADIO");
    //   } else if (result.event == "TEXT") {
    //     this.addSurveyQuestion("TEXT");
    //   } else if (result.event == "RANGE") {
    //     this.addSurveyQuestion("RANGE");
    //   }
    // });
  }

  displayPopover(event) {
    document.getElementById("passwordPopOver").style.display = "block";
  }
  closePopover() {
    document.getElementById("passwordPopOver").style.display = "none";
  }
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(
      this.surveyForm.get("SurveyQuestionArray")["controls"],
      event.previousIndex,
      event.currentIndex
    );
  }

  importSurveyData() {
    const dialogRef = this.dialog.open(OfferRulesImportDialogComponent, {
      width: "20%",
      height: "40",
      data: { type: "surveytest" },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.updateSurveyTemplate(result);
      } else {
        // this.setConstants("creation");
        //  this.readyToBuild = true;
      }
    });
  }

  updateSurveyTemplate(id) {
    this.apiCall.getSurveyTemplate(id).subscribe(
      (response) => {
        if (response["message"] === "SUCCESS") {
          this.formempty = false;
          let masterSurvey = JSON.parse(response["body"]);
          this.prefillForm(masterSurvey["layoutJson"]);
        } else {
          this.router.navigate(["/app/surveys/add-survey", { id: null }]);
        }
      },
      (err) => {
        this.router.navigate(["/app/surveys/add-survey", { id: null }]);
      }
    );
  }
  backPressed() {
    this.router.navigate(["/app/surveys/survey/view"]);
  }
  getScript(){
    let ispos = this.tokenStorage.getMerchantOnlineStore();
    if(ispos === 'shopify'){
      return this.scriptUrl;
    }
    else{
      return this.scriptPosUrl;
    }
  }
  getShopName(){
    let ispos = this.tokenStorage.getMerchantOnlineStore();
    if(ispos === 'shopify'){
      return 'shopify';
    }
    else{
      return 'pos';
    }
  }
}
